import {createSlice} from "@reduxjs/toolkit";

interface BrandState {
	selectedBrand: string;
}

const initialState: BrandState = {
	selectedBrand: localStorage.getItem("selectedBrand") || "rainstorm",
};

const brandSlice = createSlice({
	name: "brand",
	initialState,
	reducers: {
		setSelectedBrand(state, action) {
			localStorage.setItem("selectedBrand", action.payload);
			state.selectedBrand = action.payload;
		},
	},
});

export const {setSelectedBrand} = brandSlice.actions;
export default brandSlice.reducer;
